module.exports = __webpack_public_path__ + "static/img/logo.e71e6d53.png";